"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userContext = exports.shouldHaveFeature = exports.reset = exports.ldClientInstance = exports.initFeatureFlags = exports.gitContext = exports.getLDContext = exports.formatUser = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _launchdarklyJsClientSdk = require("launchdarkly-js-client-sdk");
var _environment = require("@studio/environment");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ldClientInstance;
var isLDInitialized = false;
var formatUser = exports.formatUser = function formatUser(user) {
  var ldClientUser = {
    key: user._id,
    email: user.email,
    custom: {
      createdOn: user.createdOn,
      url: user.url
    },
    privateAttributeNames: ['email'],
    url: user.url
  };
  if (user.firstName) {
    ldClientUser = _objectSpread(_objectSpread({}, ldClientUser), {}, {
      firstName: user.firstName
    });
  }
  return ldClientUser;
};
var userContext = exports.userContext = function userContext(user) {
  return _objectSpread({
    kind: 'user'
  }, formatUser(user));
};

/**
 * Git context makes git branch available to be used to enable/disable flags
 * This can be used to enable/disable flags for on-demand instances which are deployed from a feature branch
 * and can be used for both on-demand e2e tests and on-demand env for manual testing
 */
var gitContext = exports.gitContext = function gitContext() {
  var gitBranch = (0, _environment.getEnvVar)('REACT_APP_GIT_BRANCH');
  if (!!gitBranch) {
    return {
      kind: 'git',
      key: 'git',
      branch: (0, _environment.getEnvVar)('REACT_APP_GIT_BRANCH')
    };
  }
};
var getLDContext = exports.getLDContext = function getLDContext(user) {
  var LDContext = {
    kind: 'multi',
    user: userContext(user)
  };
  if (gitContext()) {
    LDContext['git'] = gitContext();
  }
  return LDContext;
};

/**
 * Initialize the feature toggler client with the user data
 */
var initFeatureFlags = exports.initFeatureFlags = function initFeatureFlags(user, clientKey) {
  return new Promise(function (ful, rej) {
    if (!clientKey) rej(new Error('Missing launchdarkly client key'));
    var logger = {
      debug: function debug() {},
      // Required — even if we don’t use it.
      info: function info() {},
      warn: function warn() {
        var _console;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (_console = console).warn.apply(_console, ['[LaunchDarkly]'].concat(args));
      },
      error: function error() {
        var _console2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return (_console2 = console).error.apply(_console2, ['[LaunchDarkly]'].concat(args));
      }
    };
    exports.ldClientInstance = ldClientInstance = (0, _launchdarklyJsClientSdk.initialize)(clientKey, getLDContext(user), {
      flushInterval: 3 * 1000,
      // 3 seconds; interval for sending batched events to LaunchDarkly.
      logger: logger
    });
    ldClientInstance.waitForInitialization().then(function () {
      // initialization succeeded, flag values are now available
      isLDInitialized = true;
      ful('ready');
    })["catch"](function (err) {
      // initialization failed
      isLDInitialized = false;
      rej(err);
    });
  });
};

/**
 * Check to see if we should show a feature
 */
var shouldHaveFeature = exports.shouldHaveFeature = function shouldHaveFeature(feature) {
  if (!isLDInitialized || !ldClientInstance) {
    return false;
  }
  return ldClientInstance.variation(feature, false);
};
var reset = exports.reset = function reset() {
  exports.ldClientInstance = ldClientInstance = undefined;
  isLDInitialized = false;
};